// extracted by mini-css-extract-plugin
module.exports = {"bb-partners":"bb-partners__L_XGs"};